/* istanbul ignore file */
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  circularProgressHolder: {
    position: "relative",
    minHeight: "calc(100vh - 41px)"
  },
  circularProgressLoader: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  }
});


const Loading = () => {
  const classes = useStyles();

  return (
    <div className={classes.circularProgressHolder}>
      <span className={classes.circularProgressLoader}>
        <CircularProgress/>
      </span>
    </div>
  )
}

export default Loading;